'use client';
import {LeadFormProps} from '@new-components/organisms/LeadForm';
import React from 'react';
import {AdditionalLeadProps, LeadGeneration} from '.';
import useLeadMetaQuery from '@hooks/querys/useLeadMeta';
import useProjectListQuery from '@hooks/querys/useProjectList';

type PayloadType = Pick<LeadFormProps, 'formType'> & AdditionalLeadProps;
type LeadGenContextType = {
  show: (data: PayloadType) => Promise<any>;
};
export const LeadFormContext = React.createContext<LeadGenContextType | null>(
  null
);
type LeadGenProviderProps = {children: React.ReactNode};
export const LeadFormProvider = ({children}: LeadGenProviderProps) => {
  const [open, setOpen] = React.useState(false);
  const [leadData, setLeadData] = React.useState<PayloadType>({
    formType: 'PROPERTY_FORM',
    id: null,
  });
  const [resolvePromise, setResolvePromise] = React.useState<
    ((data: {status: 'done'}) => void) | null
  >(null);

  const leadMeta = useLeadMetaQuery().data;
  const projectMeta = useProjectListQuery().data;

  const show = (data: PayloadType) => {
    setOpen(true);
    setLeadData(data);
    return new Promise((resolve) => {
      setResolvePromise(() => resolve);
    });
  };
  const onClose = () => {
    setOpen(false);
    resolvePromise?.({status: 'done'});
  };

  return (
    <LeadFormContext.Provider value={{show}}>
      {children}
      <LeadGeneration
        countryCodeOptions={leadMeta?.countryCode ?? []}
        languageOptions={leadMeta?.preferredLanguages ?? []}
        nationalityOptions={leadMeta?.nationalities ?? []}
        cityOptions={leadMeta?.cities ?? {}}
        retailCategoryOptions={[]}
        interestOptions={projectMeta?.interests ?? []}
        projectOptions={projectMeta?.projects ?? []}
        {...leadData}
        open={open}
        onClose={onClose}
        breadcrumbs={[]}
      />
    </LeadFormContext.Provider>
  );
};

export const useLeadForm = () => {
  const context = React.useContext(LeadFormContext);
  if (!context) {
    throw new Error('useLeadForm must be used within a LeadFormProvider');
  }
  return context;
};
